'use client';

import React from 'react';
import Footer, { Props as FooterProps } from 'components/commercetools-ui/organisms/footer';
import { FooterLink } from 'components/commercetools-ui/organisms/footer/atoms/column';
import { TasticProps } from '../types';
import { MarketProvider } from 'context/market';

interface Props extends FooterProps {
  data?: any;
}

type INavigation = {
    label: string;
    link: any;
    open_in_new_tab:boolean
}

const FooterTastic = ({ data }: TasticProps<Props>) => {
  const columns = data?.data?.dataSource?.navigation?.map((nav: INavigation) => {
    return {
      header: nav?.label,
      links: nav?.link,
      openInNewTab: !!nav?.open_in_new_tab
    };
  });
  return (
    <div className="fixed-screen-width lg:relative-width">
      <MarketProvider>
        <Footer
          logo={data?.data?.dataSource?.logo?.url}
          columns={columns}
          socialMedia={data?.data?.dataSource?.social_media?.social_media_share}
          copyright={data?.data?.dataSource?.copyright}
        />
      </MarketProvider>
    </div>
  );
};

export default FooterTastic;
